import { apiClient } from '~/api/client';
import { endpoints } from '~/api/endpoints';
import type { NavigationResponse } from '~/types/navigation.types';

export function fetchNavigation(): Promise<NavigationResponse> {
  return apiClient.get(endpoints.screens.navigation()).json<NavigationResponse>();
}
